module.exports = __webpack_public_path__ + "static/img/tabela.37f6e56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/frutuba_limao/tabela.png
// module id = 6vZi
// module chunks = 0